import { Link } from "react-router-dom";

export const Logo = ({ to = "/", dark = false }) => (
  <Link to={to} className="flex items-center gap-2" data-testid="logo-link">
    <span className="grid h-8 w-8 place-items-center rounded-lg bg-indigo-600 font-display text-sm font-extrabold text-white">SR</span>
    <span className={`font-display text-lg font-bold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
      StaffRotas<span className="text-indigo-600">.com</span>
    </span>
  </Link>
);
